import { render, staticRenderFns } from "./indexCanpin.vue?vue&type=template&id=40436062&scoped=true&"
import script from "./indexCanpin.vue?vue&type=script&lang=js&"
export * from "./indexCanpin.vue?vue&type=script&lang=js&"
import style1 from "./indexCanpin.vue?vue&type=style&index=1&id=40436062&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40436062",
  null
  
)

export default component.exports